import wrappedFetch from 'common/api/base';
import { FC, useState } from 'react';
import { reactToastify, TOASTIFY_TYPES } from 'v3/common/utils/reactToastify';

type ThemeTogglerProps = {
  currentTheme: 'light' | 'dark';
};

const ThemeToggler: FC<ThemeTogglerProps> = ({ currentTheme }) => {
  const [themeForUI, setThemeForUI] = useState<'light' | 'dark'>(currentTheme);
  const [isToggling, setIsToggling] = useState(false);
  const onChangeTheme = async () => {
    if (isToggling) return;
    setIsToggling(true);

    const newTheme = currentTheme === 'light' ? 'dark' : 'light';
    setThemeForUI(newTheme);

    try {
      await wrappedFetch('/user/toggle_theme', { method: 'PUT' });

      setTimeout(() => {
        window.location.reload();
      }, 300);
    } catch (error) {
      console.error('Failed to toggle theme:', error);
      reactToastify('Failed to reset site tour. Please try again.', TOASTIFY_TYPES.ERROR);
      setIsToggling(false);
      setThemeForUI(currentTheme);
    }
  };

  const alternateTheme = currentTheme === 'light' ? 'dark' : 'light';

  return (
    <>
      <div className="theme-toggler-container" onClick={onChangeTheme}>
        <div className="d-flex align-items-center">
          <i className="fa-regular fa-toggle-on me-2"></i>
          <h6 className="theme-toggler-title">Theme Switch</h6>
          <div
            className="theme-toggler"
            data-toggle="tooltip"
            data-placement="bottom"
            title={`Switch to the ${alternateTheme} theme`}
            onClick={onChangeTheme}
          >
            <input type="checkbox" id="theme-switch" checked={themeForUI === 'dark'} readOnly />
            <div className="slider d-none">
              <div className={`slider-icons ${themeForUI}`}>
                <svg className="icon sun" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M12 4V2M12 22v-2M4.22 4.22L2.81 2.81M21.19 21.19l-1.41-1.41M4 12H2m20 0h-2M4.22 19.78l-1.41 1.41M21.19 2.81l-1.41 1.41M12 8a4 4 0 100 8 4 4 0 000-8z"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <svg className="icon moon" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ThemeToggler;
